import Axios from 'axios'

const featureFlag = {
  getFeatureFlags(){
    return Axios.get('api/v1/feature-flags')
  },
  getFeatureFlag(featureId) {
    return Axios.get(`api/v1/feature-flags/${featureId}`)
  },
  deleteFeatureFlag(featureId){
    return Axios.delete(`api/v1/feature-flags/${featureId}`)
  },
  activateFeatureFlag (featureId){
    return Axios.patch(`api/v1/feature-flags/${featureId}/activate`)
  },
  deactivateFeatureFlag (featureId){
    return Axios.patch(`api/v1/feature-flags/${featureId}/deactivate`)
  },
  createFeatureFlag(body) {
    return Axios.post('api/v1/feature-flags', body)
  },
  updateFeatureFlag(body) {
    return Axios.put('api/v1/feature-flags', body)
  }
}

export default featureFlag